import { render, staticRenderFns } from "./Themes.vue?vue&type=template&id=2d6f72c8&scoped=true&"
import script from "./Themes.vue?vue&type=script&lang=js&"
export * from "./Themes.vue?vue&type=script&lang=js&"
import style0 from "./Themes.vue?vue&type=style&index=0&id=2d6f72c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6f72c8",
  null
  
)

export default component.exports